import { SelectOption } from '@components/Select'

export const yearsInBusinessOptions = Array.from(Array(20).keys())
  .map((i) => ({
    value: (i + 1).toString(),
    label: (i + 1).toString(),
  }))
  .concat([{ value: '21', label: 'More than 20' }])

export const professionOptions: SelectOption[] = [
  { value: 'CONSUMER', label: 'Consumer' },
  { value: 'DEALDIST', label: 'Distributor/Wholesaler' },
  { value: 'INTDESIGNR', label: 'Residential Interior Designer' },
  { value: 'ARCHITECT', label: 'Architect' },
  { value: 'PURCHAGENT', label: 'Purchasing/Procurement' },
  { value: 'INSTALL', label: 'Flooring Dealer/Installer' },
  { value: 'HOSPITINST', label: 'Hospitality' },
  { value: 'STOREDES', label: 'Store Design' },
  { value: 'RESIDINSTA', label: 'Residential Installer' },
  { value: 'COMINSTALL', label: 'Commercial Installer' },
  { value: 'INTDESIGN', label: 'Commercial Interior Designer' },
  { value: 'OTHER', label: 'Other' },
]

export const fileInputClasses =
  'file-input cursor-pointer inline-block w-full px-3 py-1.5 text-gray-700 bg-white bg-clip-padding border border-solid border-outlined-gray transition ease-in-out m-0 mt-2 focus:text-gray-700 focus:bg-white focus:border-dark focus:outline-none'
